export const TOMB_TICKER = 'BERRY';
export const TSHARE_TICKER = 'BSHARE';
export const TBOND_TICKER = 'BBOND';
export const AVAX_TICKER = 'AVAX';
export const WAVAX_TICKER = 'WAVAX';
export const TRADERJOE_ROUTER_ADDR = '0x60aE616a2155Ee3d9A68541Ba4544862310933d4';
export const ZAPPER_ROUTER_ADDR = '0x8bb1fe7a50082623b372d857b4d07911c786a3e9';
export const TAX_OFFICE_ADDR = '0xcaf6C0FB8Bcb737C2D5D7e5Db615147a26091De1';
